import React from "react";
import { StoryDetailsFields } from "../StoryDetailsFields";
import type { AgentStoryDetailsStepProps } from "./AgentStoryDetailsStep.types";

/**
 * Agent details step body — Figma 5326:88960.
 *
 * The AI frame (5326:88121) minus its Audience field: an agent already carries
 * its own audience, so this frame collects only the goal and the sources its
 * planner may read. Both come from `StoryDetailsFields`, which is why this body
 * has no markup of its own — the frame's only other difference is the header
 * copy, and that is the registry's job, not the body's.
 */
export const AgentStoryDetailsStep: React.FC<AgentStoryDetailsStepProps> = ({
  values,
  onChange,
  context,
}) => (
  <StoryDetailsFields values={values} onChange={onChange} context={context} />
);

export default AgentStoryDetailsStep;
